import styled from 'styled-components';
import { COLOR_WHITE } from '../../../assets/styles/colors';
import { rgba } from 'polished';

export default styled.div`
  height: 0;
  width: 0;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;
  .popup-overlay {
    overflow-y: auto;
    background-color: ${rgba('#2F2E41', 0.9)} !important;
  }
  .close-button {
    background: none;
    border: none;
    position: absolute;
    top: 16px;
    right: 17px;
    width: 24px;
    padding: 0px;
    margin: 0;
    opacity: 1;
    &:hover {
      opacity: 0.4;
    }
    &:focus,
    &:active {
      outline: none;
      box-shadow: none;
    }
    svg {
      width: 100%;
    }
  }

  .wishmaker-modal {
    &-content {
      border: none !important;
      width: 800px !important;
      background: ${COLOR_WHITE} !important;
      border-radius: 12px;
      padding: 50px 40px !important;
    }
    &-sm-content {
      border: none !important;
      width: 650px !important;
      background: ${COLOR_WHITE} !important;
      border-radius: 12px;
      padding: 50px 40px !important;
    }
    &-special-content {
      border: none !important;
      width: 583px !important;
      background: ${COLOR_WHITE} !important;
      border-radius: 12px;
      padding: 48px 48px !important;
    }
    &-report-content {
      border: none !important;
      width: 850px !important;
      background: ${COLOR_WHITE} !important;
      border-radius: 12px !important;
      padding: 48px 48px !important;
    }
  }
`;
